import { throttle } from '@solid-primitives/scheduled';
import { createRoot } from 'solid-js';
import { createStore } from 'solid-js/store';

interface ENV {
  isDev: boolean;
  isTest: boolean;
  isProd: boolean;
  /** 客户端尺寸 */
  clientWidth: number;
  /** 当前的rem缩放因子 */
  remScale: number;
  /** 图片域名 */
  imgHost: string;
  /** 是否是巴西的域名 */
  isBrHost: boolean;
  /** 网站版本x.x.xxx */
  version: string;
  /** 网站名称 */
  siteName: string;
  /** 平台币 */
  platformCoin: string;
  /** 支持邮箱 */
  SUPPORT: string;
  /** 反馈 */
  FEEDBACK: string;
  /** 初始参数 */
  initSearchParams: URLSearchParams;
  /** 初始hash */
  initHashParams: string;
  /** 系统支持的所有语言 */
  langs: Record<string, [string, string]>;
}

export const [env, setEnv] = createRoot(() => {

  const [env, setEnv] = createStore<ENV>({
    platformCoin: 'PLATFORMCOIN',
    siteName: 'SITENAME',
    initSearchParams: new URLSearchParams(location.search),
    initHashParams: location.hash,
    langs: {}
  } as any);

  return [env, setEnv] as const;
});
